"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageVX = exports.PageLoading = exports.LayoutMain = exports.CmpWidgetVXStatusBase = exports.CmpWidgetVXSAppBase = exports.CmpWidgetVXAppBase = exports.CmpWidgetTabTable = exports.CmpWidgetInfoVXS = exports.CmpWidgetInfoVX = exports.CmpWidgetInfoSV = exports.CmpWidgetInfoLPX = exports.CmpWidgetDetails = exports.CmpTableListItemShort = exports.CmpTableListHeaderShort = exports.CmpSearch = exports.CmpRangeBase = exports.CmpPriceRange = exports.CmpModalDialogBase = exports.CmpInputTokensSwap = exports.CmpInputTokenAmountBase = exports.CmpInfo3Steps = exports.CmpHeroVXBase = exports.CmpHeaderBase = exports.CmpFormItemAddressPath = exports.CmpFooter = exports.CmpBtnWithTag = exports.CmpBtnInfoBase = void 0;
const gs = require("@ivanlog/gs");
class CmpBtnInfoBaseControls {
    constructor(ctrls) {
        this.btn = ctrls.get('btn');
        this.lText = ctrls.get('lText');
    }
}
class CmpBtnInfoBase extends gs.WrapperGS {
    constructor() {
        super("cmpBtnInfo");
        this.ctrls = new CmpBtnInfoBaseControls(this._controls);
    }
}
exports.CmpBtnInfoBase = CmpBtnInfoBase;
class CmpBtnWithTagControls {
    constructor(ctrls) {
        this.btn = ctrls.get('btn');
        this.lTag = ctrls.get('lTag');
    }
}
class CmpBtnWithTag extends gs.WrapperGS {
    constructor() {
        super("cmpBtnWithTag");
        this.ctrls = new CmpBtnWithTagControls(this._controls);
    }
}
exports.CmpBtnWithTag = CmpBtnWithTag;
class CmpFooterControls {
    constructor(ctrls) {
    }
}
class CmpFooter extends gs.WrapperGS {
    constructor() {
        super("cmpFooter");
        this.ctrls = new CmpFooterControls(this._controls);
    }
}
exports.CmpFooter = CmpFooter;
class CmpFormItemAddressPathControls {
    constructor(ctrls) {
        this.btnInfo = ctrls.get('btnInfo');
        this.lLabel = ctrls.get('lLabel');
        this.btnAdd = ctrls.get('btnAdd');
        this.btnRemove = ctrls.get('btnRemove');
        this.iValue = ctrls.get('iValue');
    }
}
class CmpFormItemAddressPath extends gs.WrapperGS {
    constructor() {
        super("cmpFormItemAddressPath");
        this.ctrls = new CmpFormItemAddressPathControls(this._controls);
    }
}
exports.CmpFormItemAddressPath = CmpFormItemAddressPath;
class CmpHeaderBaseControls {
    constructor(ctrls) {
        this.tagPLS = ctrls.get('tagPLS');
        this.tagWrongChain = ctrls.get('tagWrongChain');
        this.btnConnect = ctrls.get('btnConnect');
        this.btnMenu = ctrls.get('btnMenu');
        this.blockMobileNav = ctrls.get('blockMobileNav');
    }
}
class CmpHeaderBase extends gs.WrapperGS {
    constructor() {
        super("cmpHeader");
        this.ctrls = new CmpHeaderBaseControls(this._controls);
    }
}
exports.CmpHeaderBase = CmpHeaderBase;
class CmpHeroVXBaseControls {
    constructor(ctrls) {
        this.blockTags = ctrls.get('blockTags');
        this.lAPR = ctrls.get('lAPR');
        this.btnInfo = ctrls.get('btnInfo');
        this.lBtnInfo = ctrls.get('lBtnInfo');
        this.blockLoading = ctrls.get('blockLoading');
    }
}
class CmpHeroVXBase extends gs.WrapperGS {
    constructor() {
        super("cmpHeroVX");
        this.ctrls = new CmpHeroVXBaseControls(this._controls);
    }
}
exports.CmpHeroVXBase = CmpHeroVXBase;
class CmpInfo3StepsControls {
    constructor(ctrls) {
        this.list = ctrls.get('list');
        this.btnInfo1 = ctrls.get('btnInfo1');
        this.lStep1 = ctrls.get('lStep1');
        this.lStep1Info = ctrls.get('lStep1Info');
        this.btnInfo2 = ctrls.get('btnInfo2');
        this.lStep2 = ctrls.get('lStep2');
        this.lStep2Info = ctrls.get('lStep2Info');
        this.btnInfo3 = ctrls.get('btnInfo3');
        this.lStep3 = ctrls.get('lStep3');
        this.lStep3Info = ctrls.get('lStep3Info');
        this.lComment = ctrls.get('lComment');
    }
}
class CmpInfo3Steps extends gs.WrapperGS {
    constructor() {
        super("cmpInfo3Steps");
        this.ctrls = new CmpInfo3StepsControls(this._controls);
    }
}
exports.CmpInfo3Steps = CmpInfo3Steps;
class CmpInputTokenAmountBaseControls {
    constructor(ctrls) {
        this.iValue = ctrls.get('iValue');
        this.lSubText = ctrls.get('lSubText');
        this.imgIcon = ctrls.get('imgIcon');
        this.lTokenName = ctrls.get('lTokenName');
    }
}
class CmpInputTokenAmountBase extends gs.WrapperGS {
    constructor() {
        super("cmpInputTokenAmount");
        this.ctrls = new CmpInputTokenAmountBaseControls(this._controls);
    }
}
exports.CmpInputTokenAmountBase = CmpInputTokenAmountBase;
class CmpInputTokensSwapControls {
    constructor(ctrls) {
        this.cmpInputTokenAmount0 = ctrls.get('cmpInputTokenAmount0');
        this.cmpInputTokenAmount1 = ctrls.get('cmpInputTokenAmount1');
    }
}
class CmpInputTokensSwap extends gs.WrapperGS {
    constructor() {
        super("cmpInputTokensSwap");
        this.ctrls = new CmpInputTokensSwapControls(this._controls);
    }
}
exports.CmpInputTokensSwap = CmpInputTokensSwap;
class CmpModalDialogBaseControls {
    constructor(ctrls) {
        this.background = ctrls.get('background');
        this.container = ctrls.get('container');
        this.btnClose = ctrls.get('btnClose');
        this.lTitle = ctrls.get('lTitle');
        this.lText = ctrls.get('lText');
        this.btnOk = ctrls.get('btnOk');
        this.btnNo = ctrls.get('btnNo');
        this.btnCancel = ctrls.get('btnCancel');
    }
}
class CmpModalDialogBase extends gs.WrapperGS {
    constructor() {
        super("cmpModalDialog");
        this.ctrls = new CmpModalDialogBaseControls(this._controls);
    }
}
exports.CmpModalDialogBase = CmpModalDialogBase;
class CmpPriceRangeControls {
    constructor(ctrls) {
    }
}
class CmpPriceRange extends gs.WrapperGS {
    constructor() {
        super("cmpPriceRange");
        this.ctrls = new CmpPriceRangeControls(this._controls);
    }
}
exports.CmpPriceRange = CmpPriceRange;
class CmpRangeBaseControls {
    constructor(ctrls) {
        this.background = ctrls.get('background');
        this.cursor = ctrls.get('cursor');
    }
}
class CmpRangeBase extends gs.WrapperGS {
    constructor() {
        super("cmpRange");
        this.ctrls = new CmpRangeBaseControls(this._controls);
    }
}
exports.CmpRangeBase = CmpRangeBase;
class CmpSearchControls {
    constructor(ctrls) {
    }
}
class CmpSearch extends gs.WrapperGS {
    constructor() {
        super("cmpSearch");
        this.ctrls = new CmpSearchControls(this._controls);
    }
}
exports.CmpSearch = CmpSearch;
class CmpTableListHeaderShortControls {
    constructor(ctrls) {
    }
}
class CmpTableListHeaderShort extends gs.WrapperGS {
    constructor() {
        super("cmpTableListHeaderShort");
        this.ctrls = new CmpTableListHeaderShortControls(this._controls);
    }
}
exports.CmpTableListHeaderShort = CmpTableListHeaderShort;
class CmpTableListItemShortControls {
    constructor(ctrls) {
    }
}
class CmpTableListItemShort extends gs.WrapperGS {
    constructor() {
        super("cmpTableListItemShort");
        this.ctrls = new CmpTableListItemShortControls(this._controls);
    }
}
exports.CmpTableListItemShort = CmpTableListItemShort;
class CmpWidgetDetailsControls {
    constructor(ctrls) {
        this.blockBtns = ctrls.get('blockBtns');
        this.btnWithdraw = ctrls.get('btnWithdraw');
        this.btnTokenize = ctrls.get('btnTokenize');
        this.btnWithdrawYield = ctrls.get('btnWithdrawYield');
    }
}
class CmpWidgetDetails extends gs.WrapperGS {
    constructor() {
        super("cmpWidgetDetails");
        this.ctrls = new CmpWidgetDetailsControls(this._controls);
    }
}
exports.CmpWidgetDetails = CmpWidgetDetails;
class CmpWidgetInfoLPXControls {
    constructor(ctrls) {
    }
}
class CmpWidgetInfoLPX extends gs.WrapperGS {
    constructor() {
        super("cmpWidgetInfoLPX");
        this.ctrls = new CmpWidgetInfoLPXControls(this._controls);
    }
}
exports.CmpWidgetInfoLPX = CmpWidgetInfoLPX;
class CmpWidgetInfoSVControls {
    constructor(ctrls) {
    }
}
class CmpWidgetInfoSV extends gs.WrapperGS {
    constructor() {
        super("cmpWidgetInfoSV");
        this.ctrls = new CmpWidgetInfoSVControls(this._controls);
    }
}
exports.CmpWidgetInfoSV = CmpWidgetInfoSV;
class CmpWidgetInfoVXControls {
    constructor(ctrls) {
        this.aMain = ctrls.get('aMain');
    }
}
class CmpWidgetInfoVX extends gs.WrapperGS {
    constructor() {
        super("cmpWidgetInfoVX");
        this.ctrls = new CmpWidgetInfoVXControls(this._controls);
    }
}
exports.CmpWidgetInfoVX = CmpWidgetInfoVX;
class CmpWidgetInfoVXSControls {
    constructor(ctrls) {
        this.aMain = ctrls.get('aMain');
    }
}
class CmpWidgetInfoVXS extends gs.WrapperGS {
    constructor() {
        super("cmpWidgetInfoVXS");
        this.ctrls = new CmpWidgetInfoVXSControls(this._controls);
    }
}
exports.CmpWidgetInfoVXS = CmpWidgetInfoVXS;
class CmpWidgetTabTableControls {
    constructor(ctrls) {
        this.btnTabStake = ctrls.get('btnTabStake');
        this.btnTabUnstake = ctrls.get('btnTabUnstake');
        this.tabUnstake = ctrls.get('tabUnstake');
    }
}
class CmpWidgetTabTable extends gs.WrapperGS {
    constructor() {
        super("cmpWidgetTabTable");
        this.ctrls = new CmpWidgetTabTableControls(this._controls);
    }
}
exports.CmpWidgetTabTable = CmpWidgetTabTable;
class CmpWidgetVXAppBaseControls {
    constructor(ctrls) {
        this.blockBtnsClaim = ctrls.get('blockBtnsClaim');
        this.btnClaimUPLS = ctrls.get('btnClaimUPLS');
        this.btnClaimPLS = ctrls.get('btnClaimPLS');
        this.btnTabStake = ctrls.get('btnTabStake');
        this.btnTabUnstake = ctrls.get('btnTabUnstake');
        this.tabStake = ctrls.get('tabStake');
        this.rStakeRangePLS = ctrls.get('rStakeRangePLS');
        this.cmpStakeTokens = ctrls.get('cmpStakeTokens');
        this.lValidatorsGas = ctrls.get('lValidatorsGas');
        this.aAddUPLSToWallet1 = ctrls.get('aAddUPLSToWallet1');
        this.btnStake = ctrls.get('btnStake');
        this.btnConnect = ctrls.get('btnConnect');
        this.tabUnstake = ctrls.get('tabUnstake');
        this.cmpUnstakeTokens = ctrls.get('cmpUnstakeTokens');
        this.aAddUPLSToWallet2 = ctrls.get('aAddUPLSToWallet2');
        this.btnUnstake = ctrls.get('btnUnstake');
    }
}
class CmpWidgetVXAppBase extends gs.WrapperGS {
    constructor() {
        super("cmpWidgetVXApp");
        this.ctrls = new CmpWidgetVXAppBaseControls(this._controls);
    }
}
exports.CmpWidgetVXAppBase = CmpWidgetVXAppBase;
class CmpWidgetVXSAppBaseControls {
    constructor(ctrls) {
        this.btnTabStrategy = ctrls.get('btnTabStrategy');
        this.btnTabExecutor = ctrls.get('btnTabExecutor');
        this.btnTabVX = ctrls.get('btnTabVX');
        this.tabStrategy = ctrls.get('tabStrategy');
        this.blockConnect = ctrls.get('blockConnect');
        this.btnConnect = ctrls.get('btnConnect');
        this.lHowWork = ctrls.get('lHowWork');
        this.formConfig = ctrls.get('formConfig');
        this.iVXSConfig_uPLSInStake = ctrls.get('iVXSConfig_uPLSInStake');
        this.iVXSConfig_SendPLSIndex = ctrls.get('iVXSConfig_SendPLSIndex');
        this.iVXSConfig_SendPLSReceiver = ctrls.get('iVXSConfig_SendPLSReceiver');
        this.iVXSConfig_BnSIndex = ctrls.get('iVXSConfig_BnSIndex');
        this.rbSwapRouter = ctrls.get('rbSwapRouter');
        this.blockSwapPath = ctrls.get('blockSwapPath');
        this.cmpSwapPath0 = ctrls.get('cmpSwapPath0');
        this.iVXSConfig_SwapMinPLSAmount = ctrls.get('iVXSConfig_SwapMinPLSAmount');
        this.iVXSConfig_SwapMaxPLSAmount = ctrls.get('iVXSConfig_SwapMaxPLSAmount');
        this.cbUseBurn = ctrls.get('cbUseBurn');
        this.blockBnSAddress = ctrls.get('blockBnSAddress');
        this.iVXSSConfig_SendAddress = ctrls.get('iVXSSConfig_SendAddress');
        this.lVXSConfigStats = ctrls.get('lVXSConfigStats');
        this.lVXSConfigStrategyAddress = ctrls.get('lVXSConfigStrategyAddress');
        this.lVXSConfigStrategyUPLS = ctrls.get('lVXSConfigStrategyUPLS');
        this.btnSubmitStrategy = ctrls.get('btnSubmitStrategy');
        this.tabExecutor = ctrls.get('tabExecutor');
        this.formExecutor = ctrls.get('formExecutor');
        this.iVXSBot_SwapFrequencyHours = ctrls.get('iVXSBot_SwapFrequencyHours');
        this.iVXSBot_SplitFrequencyHours = ctrls.get('iVXSBot_SplitFrequencyHours');
        this.iVXSBot_SplitMinProfitAmount = ctrls.get('iVXSBot_SplitMinProfitAmount');
        this.iVXSBot_MaxGasAmount = ctrls.get('iVXSBot_MaxGasAmount');
        this.btnSubmitExecutor = ctrls.get('btnSubmitExecutor');
        this.blockDeposit = ctrls.get('blockDeposit');
        this.formDeposit = ctrls.get('formDeposit');
        this.iVXSConfig_DepositUPLS = ctrls.get('iVXSConfig_DepositUPLS');
        this.btnDepositUPLS = ctrls.get('btnDepositUPLS');
        this.blockWithdraw = ctrls.get('blockWithdraw');
        this.formWithdraw = ctrls.get('formWithdraw');
        this.btnWithdrawUPLS = ctrls.get('btnWithdrawUPLS');
        this.btnWithdrawPLS = ctrls.get('btnWithdrawPLS');
    }
}
class CmpWidgetVXSAppBase extends gs.WrapperGS {
    constructor() {
        super("cmpWidgetVXSApp");
        this.ctrls = new CmpWidgetVXSAppBaseControls(this._controls);
    }
}
exports.CmpWidgetVXSAppBase = CmpWidgetVXSAppBase;
class CmpWidgetVXStatusBaseControls {
    constructor(ctrls) {
        this.lTotalStakePLS = ctrls.get('lTotalStakePLS');
        this.lRate = ctrls.get('lRate');
        this.lYourStakePLS = ctrls.get('lYourStakePLS');
        this.lYourStakeUPLS = ctrls.get('lYourStakeUPLS');
        this.lValidators = ctrls.get('lValidators');
        this.lValidatorsExiting = ctrls.get('lValidatorsExiting');
        this.lTotalStakeUPLS = ctrls.get('lTotalStakeUPLS');
        this.lInstWithdrawal = ctrls.get('lInstWithdrawal');
        this.lTotalWithdrawal = ctrls.get('lTotalWithdrawal');
        this.lVXAddress = ctrls.get('lVXAddress');
        this.lVPoolAddress = ctrls.get('lVPoolAddress');
    }
}
class CmpWidgetVXStatusBase extends gs.WrapperGS {
    constructor() {
        super("cmpWidgetVXStatus");
        this.ctrls = new CmpWidgetVXStatusBaseControls(this._controls);
    }
}
exports.CmpWidgetVXStatusBase = CmpWidgetVXStatusBase;
class LayoutMainControls {
    constructor(ctrls) {
        this.cmpHeader = ctrls.get('cmpHeader');
        this.cmpTxLock = ctrls.get('cmpTxLock');
        this.pageContainer = ctrls.get('pageContainer');
        this.cmpFooter = ctrls.get('cmpFooter');
    }
}
class LayoutMain extends gs.WrapperGS {
    constructor() {
        super("layoutMain");
        this.ctrls = new LayoutMainControls(this._controls);
    }
}
exports.LayoutMain = LayoutMain;
class PageLoadingControls {
    constructor(ctrls) {
        this.cmpHeroVX = ctrls.get('cmpHeroVX');
    }
}
class PageLoading extends gs.WrapperGS {
    constructor() {
        super("pageLoading");
        this.ctrls = new PageLoadingControls(this._controls);
    }
}
exports.PageLoading = PageLoading;
class PageVXControls {
    constructor(ctrls) {
        this.cmpHeroVX = ctrls.get('cmpHeroVX');
        this.blockLeft = ctrls.get('blockLeft');
        this.widgetInfoVXS = ctrls.get('widgetInfoVXS');
        this.widgetInfoVX = ctrls.get('widgetInfoVX');
        this.widgetInfoLPX = ctrls.get('widgetInfoLPX');
        this.blockCenter = ctrls.get('blockCenter');
        this.widgetVXApp = ctrls.get('widgetVXApp');
        this.widgetVXSApp = ctrls.get('widgetVXSApp');
        this.blockRight = ctrls.get('blockRight');
        this.widgetVXStatus = ctrls.get('widgetVXStatus');
        this.widgetInfoSV = ctrls.get('widgetInfoSV');
    }
}
class PageVX extends gs.WrapperGS {
    constructor() {
        super("pageVX");
        this.ctrls = new PageVXControls(this._controls);
    }
}
exports.PageVX = PageVX;
//# sourceMappingURL=tmpls.js.map